import {Pipe, PipeTransform} from '@angular/core';
import {UtilitiesService} from "../../core/_services/utilities.service";

@Pipe({
    name: 'vehicleYearMakeModelDisplay'
})
export class VehicleYearMakeModelDisplayPipe implements PipeTransform {

    // any => Vehicle | Job | JobRequest
    transform(vehicle: any): string {
        if (UtilitiesService.isNotEmpty(vehicle)) {
            // type => Vehicle
            if (vehicle.year && vehicle.make && vehicle.model) {
                return toString(vehicle.year, vehicle.make, vehicle.model);

            // type => Job | JobRequest
            } else if (vehicle.vehicleYear && vehicle.vehicleMake && vehicle.vehicleModel) {
                return toString(vehicle.vehicleYear, vehicle.vehicleMake, vehicle.vehicleModel);
            }
        }
        return '';
    } // transform()

} // VehicleYearMakeModelDisplayPipe

function toString(year: number, make: string, model: string): string {
    return `${year} ${make} ${model}`;
} // toString()
